enum PrivateEventParticipantStatesEnum {
  InvitationAccepted = 'Invitation accepted',
  Pending = 'Pending',
}

export default PrivateEventParticipantStatesEnum;
